import {MD5, Hex, CBC, AES, Pkcs7} from 'crypto-es'
import CryptoJS from 'crypto-js'
import { v4 as uuidv4 } from 'uuid'
const apiGivenKey = 'e6080b2b950df0c3ca5d0a790f198f9f';
const apiGivenIv  = "a1d45d820e57b18f6b6c7a15ae84e8e5"
export class Encrypter {
  // 1) 固定参数补齐
  static addFixedParams(info: Record<string, string | number>): Record<string, string> {
    const timestamp = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
    const rand = Math.floor(Math.random() * 10000000000); // 随机数
    const dict: Record<string, string> = {}
    Object.keys(info).forEach((key) => {
      const value = info[key]
      if (value !== undefined && value !== null) {
        dict[key] = String(value)
      }
    })
    // 不要覆盖外部传进来的 device
    if (!dict.device) {
      dict.device = uuidv4()
    }
    dict["aps"] = "web"; // 假设平台标识
    dict["a_v"] = "1.0.0"; // 假设版本号
    dict["sign_time"] = timestamp.toString();
    dict["sign_rand"] = rand.toString();
    dict["package"] = "com.allright.storyrushweb";
    dict["sign_key"] = apiGivenKey
    dict["sign_action"] = "apidj"; // 假设你有某个动作标识
    dict["sign_djaction"] = "apidj"; // 假设你有某个动作标识
    dict["language"] = "cn"; // 语言

    return dict;
  }

  // 2) 生成 sign_data（JSON → AES-256-CBC/PKCS7 → hex）
  static createData(params: Record<string, string>) {
    try {
      const jsonStr = JSON.stringify(params);
      console.log(jsonStr); // Debug log

      return this.yooxunAES256String(jsonStr);
    } catch (error) {
      return null;
    }
  }

  private static yooxunAES256String(input: string) {
    const keyMD5 = this.md5Hex(apiGivenKey); // 使用实际的API密钥
    const ivMD5 = this.md5Hex(apiGivenIv); // 使用实际的IV
    const iv = ivMD5.substring(8, 24); // 从IV的MD5中提取16个字节

    // 使用 crypto-js 进行加密
    const encrypted = CryptoJS.AES.encrypt(
        input,
        CryptoJS.enc.Utf8.parse(keyMD5),
        {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    // 返回十六进制字符串
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  }

  // 3) 生成 sign_sign（按 sign_rand 决定 key 排序方向 → 拼值 → Base64 → MD5）
  static createSign(params: Record<string, string>) {
    const dict: Record<string, string> = { ...params };
    const random = Number(dict["sign_rand"] || 0);
    const ascending = (random % 2 === 0);

    const sortedKeys = Object.keys(dict).sort((lhs, rhs) => {
      const cmp = lhs.localeCompare(rhs);
      return ascending ? cmp : -cmp;
    });

    let concatenated = '';
    sortedKeys.forEach(key => {
      concatenated += String(dict[key]);
    });

    concatenated = unescape(encodeURIComponent(concatenated))
    const base64 = btoa(concatenated);
    return this.md5Hex(base64);
  }

  // 4) 一键出参
  static createRequestParams(info: Record<string, string | number>): Record<string, string> {
    const fixed = this.addFixedParams(info)
    const signData = this.createData(fixed) ?? ''
    const signSign = this.createSign(fixed) ?? ''
    const out: Record<string, string> = {
      sign_sign: signSign,
      sign_data: signData
    }
    if (info.sign_curpage) {
      out.sign_curpage = String(info.sign_curpage)
    }
    return out
  }

  // MARK: - Helpers
  private static md5Hex(str: string): string {
    return MD5(str).toString(Hex);
  }

  // AES-256-CBC + PKCS7Padding（使用 crypto 模块）
  private static aes256EncryptCBCPKCS7(data: string, keyHex32: string, ivHex16: string): string {
    // 1) 将十六进制字符串转换为 Uint8Array
    const key = Hex.parse(keyHex32);
    const iv = Hex.parse(ivHex16);

    // 2) 使用 AES-256-CBC 加密
    const encrypted = AES.encrypt(data, key, {
        iv,
        mode: CBC,
        padding: Pkcs7,
    });

    // 3) 返回加密结果的 Base64 字符串
    return encrypted.toString();
  }
}
